<template>
  <v-row>
    <v-col>
      <v-row>
        <v-spacer></v-spacer>
        <v-col class="mt-0 mb-0" cols="12" sm="3">
          <v-text-field
            :autocomplete="autocompleteValueLocal"
            class="mr-3 pl-5 to-upper"
            :label="$t('vehicles.search')"
            autofocus
            @input="debounceInput"
            prepend-icon="mdi-magnify"
            v-bind:clearable="true"
            clear-icon="mdi-close"
            v-model="search"
            :outlined="is_boxes"
            :dense="is_boxes"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-data-table
          :footer-props="{
            'items-per-page-options': dataTableOptions,
          }"
          fixed-header
          :headers="headers"
          :options="options"
          :server-items-length="totalItems"
          :loading="isLoading"
          :loading-text="this.$t('loading')"
          class="elevation-0"
          :height="'calc(-200px + 100vh)'"
          style="width: 100%"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :items-per-page="itemsPerPage"
          item-key="identifier"
          @update:sort-by="updateSort"
          @update:sort-desc="updateSortOrder"
          @update:page="updatePagination"
          @update:items-per-page="updateItemsPerPage"
          :items="propertyRentals"
        >
          <template v-slot:item="{ item, index }">
            <tr @click="editHistory(item)" class="mb-2">
              <td>{{ index + 1 }}</td>
              <td>{{ item.identifier }}</td>
              <td>{{ getClientName(item.client) }}</td>
              <td>{{ item.contract_reference }}</td>
              <td>{{ filterDateFormat(item.start_date) }}</td>
              <td>{{ filterDateFormat(item.end_date) }}</td>
              <td>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon dark color="warning" v-if="item.note" v-bind="attrs" v-on="on">
                      mdi-information
                    </v-icon>
                  </template>
                  <span>{{ item.note }}</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import axios from "@/plugins/axios";
import _ from "lodash";
import { API_BASE_URL } from "@/config";
import { VIEW_MODE } from "@/config";
import { EDIT_MODE } from "@/config";
import { ADD_MODE } from "@/config";
import { DEFAULT_ITEMS_PER_PAGE_OPTIONS } from "@/config";

export default {
  name: "PropertyRentalHistoryListing",
  props: {
    property: [Object],
  },
  data() {
    return {
      is_boxes: this.getCompanyPropertyFromLocalStorage("boxes_on_fields", 1),
      dataTableOptions: DEFAULT_ITEMS_PER_PAGE_OPTIONS,
      alerts: [],
      search: "",
      isLoading: true,
      totalItems: 0,
      page: 1,
      lastPage: 1,
      itemsPerPage: DEFAULT_ITEMS_PER_PAGE_OPTIONS[0],
      options: {},
      sortBy: "start_date",
      sortDesc: false,
      sortOrd: "DESC",
      sort: {},
      showAlert: false,
      token: this.$store.state.AccessToken,
      header: { Authorization: "Bearer " + this.$store.state.AccessToken },
      autocompleteValueLocal: "off",
      isDebounceCancelled: false,
      propertyRentals: [],
    };
  },
  mounted() {
    this.$store.commit("setFormMode", VIEW_MODE);
    (this.header = { Authorization: "Bearer " + this.token }), this.fetchData();
    this.autocompleteValueLocal = this.autocompleteValue();
    this.headers.push({});
    this.headers.splice(-1);
  },
  methods: {
    showRentalForm(action) {
      if (action == "add") {
        this.$store.commit("setFormMode", ADD_MODE);
        this.$store.commit("setPropertyForNewRental", this.property || null);
        return this.$router.push("/property-rentals/history/add");
      } else {
        this.$store.commit("setFormMode", EDIT_MODE);
        return this.$router.push("/property-rentals/edit");
      }
    },
    filterDateFormat(date) {
      if (!date) {
        return this.$t("rentals.not_set");
      }
      return this.formatDate(date);
    },
    getClientName(client) {
      if (!client) {
        return "";
      }
      if (client.full_name) {
        return client.full_name;
      }
      return `${client.name || ""} ${client.first_name || ""}`.trim();
    },
    debounceInput: _.debounce(function () {
      if (this.isDebounceCancelled) {
        this.isDebounceCancelled = false;
        return false;
      }
      this.fetchData();
    }, 500),
    fetchData() {
      this.isLoading = true;
      const payload = {
        page: this.page,
        items_per_page: this.itemsPerPage,
        order_by: this.sortBy,
        order_direction: this.sortOrd,
        search: this.search,
      };
      if (this.property?.id) {
        payload.property_id = this.property.id;
      }
      axios({
        method: "get",
        url: API_BASE_URL + "/property_rentals",
        headers: this.header,
        params: payload,
      })
        .then((data) => {
          this.propertyRentals = data.data.data;
          this.totalItems = data.data.total;
          this.isLoading = false;
        })
        .catch(() => {
          this.$toast.success(
            this.$t("schedulestab.something_went_wrong_while_fetching_data")
          );
        });
    },
    updatePagination(page) {
      this.page = page;
      this.fetchData();
    },
    updateItemsPerPage(itemsPerPage) {
      itemsPerPage == -1
        ? (this.itemsPerPage = this.totalItems)
        : (this.itemsPerPage = itemsPerPage);
      this.fetchData();
    },
    editHistory(item) {
      this.$store.commit("setRentalId", item.id);
      this.$router.push("/property-rentals/edit");
    },
    updateSort(sortBy) {
      if (typeof sortBy == "object") {
        this.sortBy = sortBy[0];
      } else {
        this.sortBy = sortBy;
      }
    },
    updateSortOrder(sortDesc) {
      if (typeof sortDesc == "object") {
        !sortDesc[0] ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      } else {
        !sortDesc ? (this.sortOrd = "ASC") : (this.sortOrd = "DESC");
      }
    },
  },
  computed: {
    headers() {
      return [
        { text: this.$t("rentals.s_n"), value: "", sortable: "", width: "3px" },
        {
          text: this.$t("rentals.identifier"),
          value: "identifier",
          sortable: true,
        },
        {
          text: this.$t("vehicles.client_name"),
          value: "client.full_name",
          sortable: false,
        },
        {
          text: this.$t("rentals.reference"),
          value: "contract_reference",
          sortable: false,
        },
        {
          text: this.$t("rentals.start_date"),
          value: "start_date",
          sortable: true,
        },
        { text: this.$t("rentals.end_date"), value: "end_date", sortable: "" },
        { text: this.$t("rentals.note"), value: "note", sortable: false },
      ];
    },
  },
  watch: {
    property() {
      this.fetchData();
    },
    sortOrd: {
      handler: function () {
        this.fetchData();
      },
    },
    sortBy: {
      handler: function () {
        this.fetchData();
      },
    },
  },
};
</script>
